import React, { useContext } from 'react';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmAppConfigs } from '../../../../../global/models/configuration-models';
import { DemographicsContext } from '../../../../../global/models/demographics-model';
import { AccountInfoRoutes } from '../../../../account-info/constants/routes';
import { useAccountInfoSettings } from '../../../../account-info/hooks/useAccountInfoSettings';
import { useDemographicsPerson } from '../../../../account-info/hooks/useDemographicsPerson';
import { ArcRoutes } from '../../../constants/routes';
import { withScrollTop } from '../../../../../global/components/HOCs/with-scroll-Top';
import { withLayout } from '../../../../../global/components/HOCs/with-layout';
import { GpsType } from '../../../../../global/components/layout/layout-models';
import { withForbidden } from '../../../../../global/components/HOCs/with-forbidden';
import { TcsmFeatures } from '../../../../../global/models/features-model';
import AccountInfoContainer from '../../../../account-info/components/account-info-container';
import { PersonalInformationApp } from '../../../../account-info/features/personal-info/personal-info';
import { EmploymentReview } from './employment-review';
import { NewHireEnrollmentPersonalInfoWizard } from '../wizards/new-hire-personal-info-wizards';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';
import { AnnualEnrollmentKey } from '../../../../annual-enrollment/models/annual-enrollment-models';
import EmployeeReviewProgressBar from './employee-info-review-progress-bar';
import { useEmploymentInfo } from '../../employment/useEmployment';
import { useCompensationState } from '../hooks/useCompensationState';

const PersonalInfoWrapper = withScrollTop()(withLayout(null, GpsType.NEW_HIRE_PERSONAL_INFO)(withForbidden(TcsmFeatures.PersonalInfo)(AccountInfoContainer)));

interface Props {
	appSettings: TcsmAppConfigs;
}

function EmployeeInfoCompRecordWrapper(props: Props) {

	const { appSettings } = props;
	const routeMatch = useRouteMatch();
	const app = useContext(DemographicsContext);
	const demographicsSettingsLoaded = useAccountInfoSettings(appSettings.personalInfoSettingId, appSettings.relationshipsSettingId);
	const personLoaded = useDemographicsPerson(app);
	const employmentInfoLoad = useEmploymentInfo();
	const compensationLoad = useCompensationState();
	const epiProps = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const history = useHistory();
	const dispatch = useDispatch();
	if (!demographicsSettingsLoaded || !personLoaded || !employmentInfoLoad || !compensationLoad) {
		return <LoadingCircle />;
	}

	const wizard = new NewHireEnrollmentPersonalInfoWizard(epiProps, AnnualEnrollmentKey.newHireEnrollment, app, dispatch, history);

	return (
		<>
			<EmployeeReviewProgressBar basePath={routeMatch.path} />
			<Switch>
				<Route exact path={`${routeMatch.path}${AccountInfoRoutes.PersonalInfoSegment}`}
					render={() => (
						<PersonalInfoWrapper basePath={routeMatch.path} hideBreadcrumbs>
							<PersonalInformationApp basePath={routeMatch.path} customPersonalInfoWizard={wizard} />
						</PersonalInfoWrapper>

					)}
				/>
				<Route exact path={`${routeMatch.path}${ArcRoutes.Employment}`}
					render={() => (
						<EmploymentReview />
					)}
				/>

			</Switch>
		</>
	);
}

export default EmployeeInfoCompRecordWrapper;